


import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CheckoutDataStateModel } from "../../Entites/checkoutDataState";


export const CheckOut = createFeatureSelector<CheckoutDataStateModel>('checkout');


export const CHECKOUT_SELECTOR = createSelector(
  CheckOut, checkOutState => {
      return checkOutState.dataState;
  }
);


export const CHECKOUT_SELECTOR_Feed = createSelector(
  CheckOut, checkOutState => {
      return checkOutState.checkoutStateFeed;
  }
);

